export const fileTypesOptions = [{
  label: "CSV",
  value: 'csv'
}, {
  label: 'JSON',
  value: 'json'
}]

export const delimiterOptions = [{
  label: "Tab",
  value: 'tab'
}, {
  label: "Comma",
  value: 'comma'
}, {
  label: "Semicolon",
  value: 'semicolon'
}]

export const quotecharOptions = [{
  label: "None",
  value: ''
}, {
  label: "Single quotes",
  value: 'singlequote'
}, {
  label: "Double quotes",
  value: 'doublequote'
}, {
  label: "Pipe (|)",
  value: 'pipe'
}]

export const indentOptions = [{
  label: "None",
  value: ''
}, {
  label: "Space",
  value: 1
}, {
  label: "2 Spaces",
  value: 2
}, {
  label: "4 Spaces",
  value: 4
}, {
  label: "Tab",
  value: 'tab'
}]

export const globalMergeTags = [
  ['timestamp', 'Timestamp'],
  ['currentDate', 'Current Date'],
  ['currentDate_YYYYMMDD', 'Current Date (YYYMMDD)'],
  ['siteId', 'Site ID'],
  ['siteName', 'Site Name'],
  ['siteDomain', 'Site Domain'],
  ['sweepId', 'Sweep ID'],
  ['sweepName', 'Sweep Name'],
  ['contestId', 'Contest ID']
]

export const tupleMergeTags = [
  ['ticket', 'Ticket'],
  null,
  ['firstName', 'First Name'],
  ['lastName', 'Last Name'],
  ['email', 'E-mail'],
  ['address1', 'Address 1'],
  ['address2', 'Address 2'],
  ['city', 'City'],
  ['state', 'State'],
  ['zip', 'ZIP'],
  ['country', 'Country'],
  ['gender', 'Gender'],
  ['age', 'Age'],
  ['dob_mm', 'DOB Month'],
  ['dob_dd', 'DOB Day'],
  ['dob_yyyy', 'DOB Year'],
  ['phone', 'Phone'],
  ['phone_areaCode', 'Phone Area Code'],
  ['phone_prefix', 'Phone Prefix'],
  ['phone_suffix', 'Phone Suffix'],
  null,
  ['subscription_id', 'Subscription ID'],
  ['usid', 'User Session ID'],
  ['pid', 'Publisher ID'],
  ['sid1', 'Sid1'],
  ['sid2', 'Sid2'],
  ['sid3', 'Sid3'],
  ['registration_leadid', 'Registration Leadid'],
  ['registration_trustedform', 'Registration Trustedform'],
  ['subscription_date', "Subscription Datetime"],
  ['registration_date', "Registration Datetime"],
  null,
  ['optout', 'Optout'],
  null,
  ...globalMergeTags
]

export const defaultSCAConfiguration = {
  header: false,
  columns: [
    {
      value: "{subscription_id}",
      colname: "entry_id"
    },
    {
      value: "{subscription_date}",
      colname: "date"
    },
    {
      value: "{ticket}",
      colname: "ticket"
    },
  ],
  delivery: {
    sca: {
      port: "21",
      anonymous: false,
      tls: true,
      host: "ftp.scapromotions.com",
      user: "",
      password: "",
      directory: ""
    }
  },
  delimiter: "comma",
  file_name: "{currentDate_YYYYMMDD}",
  file_type: "csv",
  quotechar: "doublequote"
}